import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../store/Store";
import {
  addEventImage,
  addEventInfo,
  createPackagePricing,
  getEventImagesById,
  getEventInfo,
  getPackagePricing,
  resetDay,
  updateEventInfo,
  updatePackagePricing,
} from "../Dashboard/modules/actions";
import { getParticipants } from "../Participants/modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    packagePricing: state.dashboardReducer.packagePricing,
    eventInfo: state.dashboardReducer.event,
    loading: state.dashboardReducer.loading,
    loggedUser: state.user.loggedUser,
    eventImages: state.dashboardReducer.eventImages,
    participants: state.participantsReducer.participants,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      getEventInfo,
      addEventInfo,
      updateEventInfo,
      getPackagePricing,
      createPackagePricing,
      updatePackagePricing,
      getEventImagesById,
      addEventImage,
      resetDay,
      getParticipants,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
